import { Component, Input, ViewEncapsulation } from '@angular/core';

import * as _ from 'underscore';

import { QuickbetPanelUpdatedComponent } from '../../../quickbet/components/quickbetPanelUpdated/quickbet-panel-updated.component';
import { ISRMBetPlacementModel } from '../../../quickbet/models/quickbet-receipt.model';

@Component({
    selector: 'srm-quickbet-panel-updated',
    templateUrl: 'srm-quickbet-panel-updated.component.html',
    styleUrls: [
        '../../../quickbet/components/quickbetPanel/quickbet-panel.component.scss',
        '../../../quickbet/components/quickbetPanelUpdated/quickbet-panel-updated.component.scss',
        'srm-quickbet-panel-updated.component.scss',
    ],
    // eslint-disable-next-line
    encapsulation: ViewEncapsulation.None,
    standalone: false,
})
export class SrmQuickbetPanelUpdatedComponent extends QuickbetPanelUpdatedComponent {
    @Input() selectionEventLocalTime: string;
    srmBetReceipt: ISRMBetPlacementModel;

    protected override placeBetListener() {
        this.quickbeReceiptSubscriber = this.quickbetDataProviderService.quickbetReceiptListener.subscribe((betReceipt) => {
            this.placeBetPending.state = false;
            if (_.isArray(betReceipt) && betReceipt[0].error) {
                console.warn('Error while placing srm bet', betReceipt[0].error);
                this.quickbetNotificationService.saveErrorMessageWithCode(betReceipt[0].error, 'warning', '', betReceipt[0].errorCode);
            } else {
                if (_.isArray(betReceipt) && betReceipt.length) {
                    this.srmBetReceipt = betReceipt[0] as ISRMBetPlacementModel;
                    this.srmBetReceipt.categoryId = this.selection.categoryId;
                    this.title = this.locale.getString(`quickbet.betReceiptTitle`);
                    this.sessionStorageService.set('betPlaced', true);

                    // Go to bet receipt state
                    this.goToState('receipt');
                    this.nativeBridgeService.betPlaceSuccessful(this.srmBetReceipt!.receipt!, this.selection.categoryName, 'Single');
                    this.quickbeReceiptSubscriber.unsubscribe();
                }
            }
        });
    }
}
